import React, { useEffect, useState } from 'react'
import { Blacked, Icon } from '../organism/Navigation/styles'
import { TiArrowSortedDown } from 'react-icons/ti'
import { FaChevronLeft } from 'react-icons/fa6'
import {
	ManageNote,
	ManageStyleModalMain,
	NoteTable,
	TableHeader,
	NoteHeader,
	TextArea,
	NoteTableWrapper,
	MobileTable,
} from './styles/modalStyles'
import { useManageLearningNote } from '../hooks/LearningNote'
import { AddManageLearningNote } from './AddManageLearningNote'
import { useToken } from 'app/hooks'
import API from 'utils/api'
import { message, Radio } from 'antd'
import { printLearningNote } from 'utils/print-lecture'

export const ManageStyleModal = ({
	selectLecture,
	selectStudentNote,
	setManageSt,
	editNoteIndex,
	handleWriteClick,
	setIsWrite,
}) => {
	const { data: token } = useToken()
	const {
		ManageLearningNoteData,
		mutate: LearningNoteMutate,
		changeDateFilter,
	} = useManageLearningNote(
		selectLecture?.id,
		selectStudentNote?.studentId || selectStudentNote?.id
	)
	const LearningNote = ManageLearningNoteData?.filter(it => it.type === 1) || []
	const monthNote = ManageLearningNoteData?.filter(it => it.type === 2) || []
	const [isAdd, setIsAdd] = useState(false)
	const [isAddMobile, setIsAddMobile] = useState(false)
	const [isFix, setIsFix] = useState(false)
	const [editingIndex, setEditingIndex] = useState(null)
	const [fixContent, setFixContent] = useState('')
	const [fixHomework, setFixHomework] = useState()
	const [fixMemo, setFixMemo] = useState()
	// -1 means "not selected" (UI shows '-')
	const [fixPrevHomeworkDone, setFixPrevHomeworkDone] = useState<number>(-1)
	const [fixMonthNote, setFixMonthNote] = useState(monthNote[0]?.content || '')

	const now = new Date()
	const year = now.getFullYear()
	const month = now.getMonth() + 1
	const day = now.getDate()
	const recentYears = Array.from({ length: 5 }, (_, idx) => year - idx)
	const sliceYear = year.toString()?.slice(-2)
	const formattedMonth = month < 10 ? `0${month}` : month
	const formattedDay = day < 10 ? `0${day}` : day
	const hours = now.getHours().toString().padStart(2, '0')
	const minutes = now.getMinutes().toString().padStart(2, '0')
	const formattedTime = `${year}-${formattedMonth}-${formattedDay} ${hours}:${minutes}`

	const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false)
	const [selectedYear, setSelectedYear] = useState(year)
	const [selectedMonth, setSelectedMonth] = useState(month)
	const [dateArrangeData, setDateArrangeData] = useState('')
	const [monthNoteDate, setMonthNoteDate] = useState('')
	const [todayMonthNoteDate, setTodayMonthNoteDate] = useState('')

	const apiurl = '/dashboard/lecture/' + selectLecture?.id + '/report/'

	// useEffect(() => {
	// 	console.log('monthNote', monthNote)
	// }, [monthNote])
	useEffect(() => {
		console.log('selectLecture', selectLecture)
		console.log('selectStudentNote', selectStudentNote)
		console.log('editNoteIndex', editNoteIndex)
		console.log('LearningNote', LearningNote)
		console.log('ManageLearningNoteData', ManageLearningNoteData)
	}, [LearningNote, selectLecture, selectStudentNote, editNoteIndex, ManageLearningNoteData])

	useEffect(() => {
		const today = new Date() // 현재 날짜 및 시간을 가져옵니다.
		today.setFullYear(selectedYear) // 선택된 년도 설정
		today.setMonth(selectedMonth - 1, 1) // 선택된 월 설정, 날짜를 1일로 설정합니다.

		// 해당 월의 마지막 날짜를 구합니다.
		const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()

		// 연도는 두 자리로 표현합니다.
		const sliceYear = today.getFullYear().toString()?.slice(-2)
		const formattedMonth = (today.getMonth() + 1).toString().padStart(2, '0')

		// 상태 업데이트 (상단의 코드에 이미 선언된 변수와 충돌하지 않도록 새로운 변수명 사용)
		const newFormattedMonthRange = `${sliceYear}-${formattedMonth}-01 ~ ${sliceYear}-${formattedMonth}-${lastDay}`

		setDateArrangeData(newFormattedMonthRange) // 날짜 필터 함수를 업데이트하는 훅 (서버 요청 등에 사용될 수 있습니다.)
	}, [selectedMonth, selectedYear])

	useEffect(() => {
		// NOTE: do NOT use toISOString() here. It converts to UTC and can shift the date/month in KST (e.g. Jan 1st -> Dec 31st).
		const today = `${year}.${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`

		const hasTodayNote = ManageLearningNoteData?.some(note => {
			const noteDate = note.createdAt.split(' ')[0]
			return noteDate === today
		})
		if (hasTodayNote) {
			setIsWrite(prevState => {
				return [
					...prevState,
					{
						id: selectLecture?.id,
						student: selectStudentNote.studentId || selectStudentNote.id,
						value: true,
					},
				]
			})
		}

		setFixMonthNote(monthNote[0]?.content.length > 0 ? monthNote[0]?.content : '')
	}, [ManageLearningNoteData, selectLecture, selectStudentNote, setIsWrite])

	const handleSaveButtonClick = () => {
		if (monthNote.length === 0) {
			API.post(apiurl, token + '', {
				type: 2,
				studentIds: [selectStudentNote.studentId || selectStudentNote.id],
				createdAt: todayMonthNoteDate === monthNoteDate ? '' : monthNoteDate,
				content: fixMonthNote,
				homework: '',
				memo: '',
			})
				.then((res: any) => {
					if (res.result.success) {
						handleWriteClick(editNoteIndex)
						message.success('저장되었습니다')
						LearningNoteMutate()
						setManageSt(false)
					}
				})
				.catch((err: any) => {})
		} else {
			API.put(
				apiurl +
					monthNote[0]?.id +
					'?studentId=' +
					(selectStudentNote.studentId || selectStudentNote.id),
				token + '',
				{
					datas: {
						content: fixMonthNote,
						createdAt: todayMonthNoteDate === monthNoteDate ? '' : monthNoteDate,
						homework: '',
						memo: '',
					},
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						handleWriteClick(editNoteIndex)
						message.success('저장되었습니다')
						LearningNoteMutate()
						setManageSt(false)
					}
				})
				.catch((err: any) => {})
		}
	}

	// ** 수정 버튼 클릭 시 해당 인덱스 요소만 수정 가능하게
	const handleFixBtnClick = idx => {
		setEditingIndex(idx)
		setIsFix(true)
		setFixContent(LearningNote[idx].content)
		setFixHomework(LearningNote[idx].homework)
		setFixMemo(LearningNote[idx].memo)
		const p = LearningNote[idx].prev_homework_done ?? LearningNote[idx].prevHomeworkDone
		setFixPrevHomeworkDone(p === undefined || p === null ? -1 : p ? 1 : 0)
	}
	// ** 수정 -> 저장 버튼으로 변경 후 API로 데이터 이동
	const handleFixSaveClick = noteId => {
		API.put(
			apiurl + noteId + '?studentId=' + (selectStudentNote.studentId || selectStudentNote.id),
				token + '',
				{
					datas: {
						content: fixContent,
						createdAt: formattedTime,
						homework: fixHomework,
						memo: fixMemo,
						prevHomeworkDone: fixPrevHomeworkDone === -1 ? null : fixPrevHomeworkDone,
					},
				}
			)
			.then((res: any) => {
				if (res.result.success) {
					message.success('수정되었습니다')
					setIsFix(false)
					setEditingIndex(null)
					LearningNoteMutate()
				}
			})
			.catch((err: any) => {})
	}
	const handleDeleteBtnClick = noteId => {
		API.delete(
			apiurl + noteId + '?studentId=' + (selectStudentNote.studentId || selectStudentNote.id),
			token + '',
			{}
		)
			.then((res: any) => {
				if (res.result.success) {
					message.success('삭제되었습니다')
					LearningNoteMutate()
				} else {
					message.error(res?.result?.message || '삭제에 실패했습니다.')
				}
			})
			.catch((err: any) => {})
	}

	const saveFixContent = e => {
		setFixContent(e.target.value)
	}
	const saveFixHomework = e => {
		setFixHomework(e.target.value)
	}
	const saveFixMemo = e => {
		setFixMemo(e.target.value)
	}
	const saveFixMonthNote = e => {
		setFixMonthNote(e.target.value)
	}

	const handleMonthSelect = (selectedMonth: number) => {
		setSelectedMonth(selectedMonth)
		setIsMonthDropdownOpen(false)
	}

	const handleMonthChange = (delta: number) => {
		let newMonth = selectedMonth + delta
		let newYear = selectedYear

		if (newMonth < 1) {
			newMonth = 12
			newYear -= 1
		} else if (newMonth > 12) {
			newMonth = 1
			newYear += 1
		}
		setSelectedMonth(newMonth)
		setSelectedYear(newYear)
	}

	const handleKeyDown = e => {
		if (e.key === 'Enter' && !e.shiftKey) {
			// 엔터 키를 누르고, shift 키를 누르지 않은 경우
			e.preventDefault() // 기본 엔터 동작 방지
			setFixContent(prevContent => prevContent + '\n')
		}
	}

	useEffect(() => {
		// NOTE: do NOT use Date#toISOString(). It converts to UTC and can shift month in KST.
		const yearMonth = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`

		changeDateFilter(yearMonth)
		setMonthNoteDate(yearMonth)
		setTodayMonthNoteDate(formattedTime?.slice(0, 7))
	}, [selectedMonth, selectedYear])

	return (
		<ManageStyleModalMain>
			<Blacked onClick={() => setManageSt(false)} />
			<ManageNote className={'ManageNote'}>
				<NoteHeader className="learningNoteHeader">
					<div className="leftBtns">
						<button
							className="message"
							onClick={() => {
								if (window.confirm('문자전송을 하시겠습니까?')) {
									API.post('/dashboard/message', token + '', {
										type: 'report',
										studentId: selectStudentNote.studentId || selectStudentNote.id,
										lectureId: selectLecture?.id,
										date: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`,
									})
										.then((res: any) => {
											if (res.result.success) {
												message.success('문자전송이 완료되었습니다')
											} else {
												message.error(res?.result?.message || '문자전송에 실패했습니다.')
											}
										})
										.catch((err: any) => {})
								}
							}}>
							문자전송
						</button>
						<Icon
							onClick={() => setManageSt(false)}
							style={{
								width: '24px',
								height: '24px',
								color: '#666666',
							}}>
							<FaChevronLeft />
						</Icon>
					</div>
					<div className="title" onClick={() => setIsMonthDropdownOpen(!isMonthDropdownOpen)}>
						<select
							className="yearSelect"
							value={selectedYear}
							onClick={e => e.stopPropagation()}
							onChange={e => {
								e.stopPropagation()
								setSelectedYear(Number(e.target.value))
								setIsMonthDropdownOpen(false)
							}}>
							{recentYears.map(y => (
								<option key={y} value={y}>
									{y}년
								</option>
							))}
						</select>
						<p>{selectStudentNote?.name}</p>
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<button
								onClick={e => {
									e.stopPropagation()
									handleMonthChange(-1)
								}}
								style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px' }}>
								&lt;
							</button>
							<span>{selectedMonth}월</span>
							{selectedYear === year && selectedMonth === month ? null : (
								<button
									onClick={e => {
										e.stopPropagation()
										handleMonthChange(1)
									}}
									style={{
										background: 'none',
										border: 'none',
										cursor: 'pointer',
										fontSize: '14px',
									}}>
									&gt;
								</button>
							)}
						</div>
						{isMonthDropdownOpen && (
							<div className="selectMonth">
								{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
									<p
										key={m}
										onClick={() => handleMonthSelect(m)}
										style={{
											backgroundColor: selectedMonth == m ? '#F78B85' : '',
											color: selectedMonth == m ? '#FFF' : '',
										}}>
										{m}월
									</p>
								))}
							</div>
						)}
						<p>학습일지</p>
						<p>
							<TiArrowSortedDown />
						</p>
					</div>
					<div className="rightBtns">
						<span
							onClick={() =>
								printLearningNote(
									LearningNote,
									monthNote,
									selectStudentNote,
									selectedMonth,
									selectLecture,
									dateArrangeData
								)
							}>
							인쇄
						</span>
						<button
							className="mobileMessage"
							onClick={() => {
								if (window.confirm('문자전송을 하시겠습니까?')) {
									API.post('/dashboard/message', token + '', {
										type: 'report',
										studentId: selectStudentNote.studentId || selectStudentNote.id,
										lectureId: selectLecture?.id,
										date: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`,
									})
										.then((res: any) => {
											if (res.result.success) {
												message.success('문자전송이 완료되었습니다')
											} else {
												message.error(res?.result?.message || '문자전송에 실패했습니다.')
											}
										})
										.catch((err: any) => {})
								}
							}}>
							전송
						</button>
						<button onClick={handleSaveButtonClick}>저장</button>
					</div>
				</NoteHeader>
				<div className="modalMain">
					<div className="tableWrapper">
						<TableHeader>
							<p>{selectLecture?.name}</p>
							<p>{dateArrangeData}</p>
						</TableHeader>
						<NoteTableWrapper>
							<NoteTable>
								<thead>
									<tr>
										<th style={{ minWidth: '80px' }}>회차</th>
										<th style={{ minWidth: '100px' }}>일자</th>
										<th style={{ width: '60%' }}>학습내용</th>
										<th style={{ width: '20%' }}>과제</th>
										<th style={{ minWidth: '80px' }}>전일 숙제</th>
										<th style={{ width: '20%' }}>비고</th>
										<th></th>
									</tr>
								</thead>
								{LearningNote?.map((it, idx) => (
									<tr key={idx} className="learningNote">
										<td>{idx + 1}</td>
										<td className="date">{it.createdAt}</td>
										<td>
											{editingIndex !== idx ? (
												it.content
											) : (
												<div>
													<textarea
														style={{
															width: '100%',
														}}
														className="contentInput"
														autoFocus
														value={fixContent}
														placeholder="학습내용 입력(필수) &#13;&#10;줄바꿈은 shift + Enter"
														onChange={saveFixContent}
														onKeyDown={handleKeyDown}
													/>
												</div>
											)}
										</td>
										<td>
											{editingIndex !== idx ? (
												it.homework
											) : (
												<textarea
													placeholder="과제 수정"
													value={fixHomework}
													onChange={saveFixHomework}
												/>
											)}
										</td>
										<td>
											{editingIndex !== idx ? (
												(it.prev_homework_done ?? it.prevHomeworkDone) == null ? '-' : (it.prev_homework_done ?? it.prevHomeworkDone) ? 'O' : 'X'
											) : (
												<Radio.Group
													value={fixPrevHomeworkDone}
													onChange={e => setFixPrevHomeworkDone(e.target.value)}
													options={[
														{ value: 1, label: 'O' },
														{ value: 0, label: 'X' },
														{ value: -1, label: '-' },
													]}
												/>
											)}
										</td>
										<td style={{ position: 'relative' }}>
											{editingIndex !== idx ? (
												it.memo
											) : (
												<input
													style={{ position: 'relative', top: -82 }}
													type="text"
													placeholder="비고 수정"
													value={fixMemo}
													onChange={saveFixMemo}
												/>
											)}
										</td>
										<td>
											{editingIndex !== idx ? (
												<div className="btns2">
													<button className="fixBtn" onClick={() => handleFixBtnClick(idx)}>
														수정
													</button>
													<button className="deleteBtn" onClick={() => handleDeleteBtnClick(it.id)}>
														삭제
													</button>
												</div>
											) : (
												<div className="btns2" style={{ position: 'relative', top: -82 }}>
													<button className="fixBtn" onClick={() => handleFixSaveClick(it.id)}>
														저장
													</button>
													<button
														className="deleteBtn"
														onClick={() => {
															setEditingIndex(null)
															setIsFix(false)
														}}>
														취소
													</button>
												</div>
											)}
										</td>
									</tr>
								))}
							</NoteTable>
							{LearningNote?.map((it, idx) => (
								<MobileTable key={idx}>
									<div className="tableHeader">
										<p>{idx + 1}회차</p>
										<p>{it.createdAt}</p>
									</div>
									<div className="tableMain">
										<div className="content">
											<h1>
												학습
												<br />
												내용
											</h1>
											<p>{it.content}</p>
										</div>
										<div className="assignment">
											<h1>과제</h1>
											<p>
												{it.homework == '' ? (
													<textarea className="assignmentMobile" placeholder="내용작성" />
												) : (
													it.homework
												)}
											</p>
										</div>
									</div>
								</MobileTable>
							))}
						</NoteTableWrapper>
						{/* 학습일지 추가버튼 클릭 */}
						<AddManageLearningNote
							isAdd={isAdd}
							setIsAdd={setIsAdd}
							isAddMobile={isAddMobile}
							setIsAddMobile={setIsAddMobile}
							selectLecture={selectLecture}
							selectStudentNote={selectStudentNote}
							formattedTime={formattedTime}
							todayMonthNoteDate={todayMonthNoteDate}
							monthNoteDate={monthNoteDate}
						/>
					</div>
					<div className="modalBottom">
						<TableHeader>
							<p style={{ fontSize: '16px' }}>월간 학습현황</p>
							<p>{monthNote?.length == 0 ? '' : `작성일 : ${monthNote[0]?.createdAt}`}</p>
						</TableHeader>
						<TextArea placeholder="내용작성" onChange={saveFixMonthNote} value={fixMonthNote} />
					</div>
					<div className="teacherArea">
						<p>담당 강사 : {selectLecture?.teacherNames?.join(', ')}</p>
					</div>
				</div>
			</ManageNote>
		</ManageStyleModalMain>
	)
}

export default React.memo(ManageStyleModal)
